import React, { FC, useEffect, useRef } from 'react';

import Header from '..';
import crossButton from '../../../static/images/close_burger_menu.svg';

import { Wrapper, Divider, Email, BurgerCloseButton } from './styles';
import SocialList from '../../SocialList';
import Navigation from '../../Navigation';
import LanguageSelector from '../../LanguageSelector';
import CurrencySelector from '../../CurrencySelector';

type TDrawer = {
  id: string;
  canOpen: boolean;
  canClose: boolean;
  onClose(): void;
};

const Drawer: FC<TDrawer> = ({ id, canOpen, canClose, onClose }) => {
  const drawerRef = useRef<HTMLDivElement | null>(null);
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    closeButtonRef.current?.focus();
  }, []);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.defaultPrevented) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      onClose();
      return;
    }
    if (event.key !== 'Tab') return;

    const items = Array.from(drawerRef.current?.querySelectorAll<HTMLElement>(
      'a[href]:not([tabindex="-1"]), button:not(:disabled):not([tabindex="-1"]), input:not(:disabled):not([tabindex="-1"]), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]'
    ) || []).filter((element) => element.getClientRects().length > 0);
    const first = items[0];
    const last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  };

  return (
    <Wrapper
      id={id}
      ref={drawerRef}
      role="dialog"
      aria-modal="true"
      aria-label="Navigation menu"
      onKeyDown={handleKeyDown}
      className={`${canClose ? 'close-animation ' : ''}${canOpen ? 'open-animation' : ''}`}
    >
      <Header>
        <BurgerCloseButton ref={closeButtonRef} type="button" aria-label="Close menu" onClick={onClose}>
          <img src={crossButton} alt="" aria-hidden="true" />
        </BurgerCloseButton>
      </Header>

      <div onClick={onClose}>
        <Navigation />
      </div>

      <Divider />

      <Email href="mailto:forestshopcarpatian@gmail.com">forestshopcarpatian@gmail.com</Email>

      <SocialList />

      <Divider />

      <CurrencySelector />
      <LanguageSelector />
    </Wrapper>
  );
};

export default Drawer;
